import 'babel-polyfill';
import 'isomorphic-fetch';
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import config from './config';
import ApiService from './services/api.service';
import TokenService from './services/storage.service';
import UserService from './services/user.service';
import axios from 'axios';
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsconfig from './aws-exports'

ApiService.init(process.env.VUE_APP_API_URL);

Amplify.configure(awsconfig)
Vue.use(AmplifyPlugin, AmplifyModules)

Amplify.configure({
  ...awsconfig,
  API: {
    endpoints: [
      {
        name: "multicloud",
        endpoint: process.env.VUE_APP_API_URL,
        region: process.env.VUE_APP_REGION
      }
    ]
  }
})

// axios.interceptors.response.use(
//   response => response,
//   async (error) => {
//     const { data, status } = error.response
    
//     if (status === 401 && data.message === "The incoming token has expired") {
//       return UserService.refreshToken()
//         .then(token => {
//           error.config.headers.Authorization = `Bearer ${token}`;

//           return axios.request(error.config)
//         })
//         .catch(async (err) => {
//           await UserService.signOut()
//           return Promise.reject(error)
//         })
//     }

//     return Promise.reject(error)
//   }
// );


if (TokenService.getToken("idToken")) {
  ApiService.setHeader()
  console.log(TokenService.getToken("idToken"));
  console.log('token exists');
}

Vue.config.productionTip = false

if(process.env.NODE_ENV === 'production') 
  Vue.config.devtools = false

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
